import $ from 'jquery';

export const initAiCreditsInfoModal = () => {
  // This function ensures the modal's event handlers are properly initialized

  // Remove existing listeners to prevent duplicates
  $(document).off('click.aiCreditsInfo', '#buy-credits-from-info');
  $('#aiCreditsInfoModal').off('shown.bs.modal.aiCreditsInfo');
  $('#aiCreditsInfoModal').off('show.bs.modal.aiCreditsInfo');
  $('#aiCreditsInfoModal').off('hidden.bs.modal.aiCreditsInfo');

  // Handle buy credits button click - same pattern as the working credits-info-btn
  $(document).on('click.aiCreditsInfo', '#buy-credits-from-info', function (e) {
    e.preventDefault();
    $('#aiCreditsInfoModal').modal('hide');

    // Wait for modal to be fully hidden before showing the next one
    setTimeout(function () {
      $('#aiCreditPackagesModal').modal('show');
      // Ensure body has modal-open class and backdrop is correct
      $('body').addClass('modal-open');
    }, 500);
  });

  // Ensure tooltips are initialized when modal is shown
  $('#aiCreditsInfoModal').on('shown.bs.modal.aiCreditsInfo', function () {
    $('[data-toggle="tooltip"]').tooltip();
  });

  // Prevent ESC key from propagating to global handlers when modal is shown
  $('#aiCreditsInfoModal').on('show.bs.modal.aiCreditsInfo', function () {
    $(this).on('keydown.aiModal', function (e) {
      if (e.keyCode === 27) {
        e.stopPropagation();
      }
    });
  });

  // Clean up event handler when modal is hidden
  $('#aiCreditsInfoModal').on('hidden.bs.modal.aiCreditsInfo', function () {
    $(this).off('keydown.aiModal');
  });
};
